const axios = require('axios').default;
import qs = require('qs');
import * as giftAidMessages from './DonationForm'

export default class AddressFinder {
    private addressFinderWrappers: NodeListOf<HTMLElement>;

    constructor() {
        this.addressFinderWrappers = document.querySelectorAll('.address-lookup-wrapper');
    }

    init() {
        if (this.addressFinderWrappers.length) {
            Array.prototype.forEach.call(this.addressFinderWrappers, (finderComponent: HTMLElement) => {

                const lookupButton = finderComponent.querySelector('.btn-find-address') as HTMLButtonElement;
                const nearestPostcodeField = finderComponent.querySelector('.postalCodeControl') as HTMLInputElement;
                const resultsSelect = finderComponent.querySelector('.address-results') as HTMLSelectElement;
                resultsSelect.parentElement.classList.add('hidden-accessible');

                nearestPostcodeField.addEventListener('input', () => {
                    lookupButton.disabled = !this.isValidPostcode(nearestPostcodeField.value);
                });

                lookupButton.addEventListener('click', () => {
                    resultsSelect.innerHTML = '<option disabled selected value="">Please select your address from the list</option>';
                    resultsSelect.removeAttribute('disabled');
                    this.findAddresses(nearestPostcodeField.value, resultsSelect);
                });

                resultsSelect.addEventListener('change', () => {
                    this.lookupAddress(resultsSelect.value, finderComponent);
                });
            });
        }
    }

    isValidPostcode(value): boolean {
        const ukPattern = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/gmi;
        return ukPattern.test(value);
    }

    lookupAddress(addressId: string, finderComponent: HTMLElement) {
        const url = 'https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3.ws';

        const params = {
            'Key': (window.location.hostname === 'localhost') ? 'WZ55-AR48-ZA96-CD33' : 'pr99-xw29-pu92-fx57',
            'Id': addressId
        }

        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(params),
            url,
        };

        const addressLine1 = finderComponent.querySelector('.addressLine1') as HTMLInputElement;
        const addressLine2 = finderComponent.querySelector('.addressLine2') as HTMLInputElement;
        const addressLine3 = finderComponent.querySelector('.addressLine3') as HTMLInputElement;
        const addressCity = finderComponent.querySelector('.city') as HTMLInputElement;
        const revealWrapper = finderComponent.querySelector('.reveal-content') as HTMLElement;
        const msgError = finderComponent.querySelector('h4.msg-error') as HTMLElement;
        let isCompany = false;

        axios(options).then(response => {
            const jsonData = response.data;
            const addressResult = jsonData.Items[0];

            addressLine1.value = addressResult.Line1 && addressResult.Line1 != 'undefined' ? addressResult.Line1 : '';
            addressLine2.value = addressResult.Line2 && addressResult.Line2 != 'undefined' ? addressResult.Line2 : '';
            addressLine3.value = addressResult.Line3 && addressResult.Line3 != 'undefined' ? addressResult.Line3 : '';
            addressCity.value = addressResult.City && addressResult.City != 'undefined' ? addressResult.City : '';
            isCompany = addressResult.Company && addressResult.Company != 'undefined' ? true : false;

            //Show this is a company address if required
            giftAidMessages.default.setGiftAidMessage(isCompany);

            revealWrapper.classList.remove('hidden-accessible');



            if (!addressResult.Line1) {
                msgError.classList.remove('hidden');
                msgError.innerHTML = 'There was a problem with the address finder. Please complete the required fields manually.';

            }

        }).then(() => {
            const resultsSelect = finderComponent.querySelector('.address-results') as HTMLSelectElement;
            resultsSelect.innerHTML = '<option disabled selected value="">Please select your address from the list</option>';

            resultsSelect.parentElement.classList.add('hidden-accessible');
        });
    }

    displayError(resultsTarget: HTMLSelectElement, error?: any) {
        if (error && error.message) {
            resultsTarget.innerHTML = '<option disabled selected value="">Sorry, something went wrong. Please re-check the entered value or enter the address manually.</option>';
        } else {
            resultsTarget.innerHTML = '<option disabled selected value="">Sorry, we couldn\'t find any addresses for that postcode. Please re-check the entered value or enter the address manually.</option>';
        }
        resultsTarget.setAttribute('disabled', '');
    }

    findAddresses(postalCode: string, resultsTarget: HTMLSelectElement, container?: string) {

        const url = 'https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws';

        let params = {
            'Key': (window.location.hostname === 'localhost') ? 'WZ55-AR48-ZA96-CD33' : 'pr99-xw29-pu92-fx57',
            'Text': postalCode.replace(' ', ''),
            'IsMiddleware': false,
            'Container': '',
            'Origin': '',
            'Countries': 'GBR',
            'Limit': '',
            'Language': 'en-gb'
        }

        if (container) {
            params.Container = container;
        }

        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(params),
            url,
        };

        axios(options).then(response => {
            const jsonData = response.data;

            if (!jsonData.Items.length) {
                this.displayError(resultsTarget);
            } else {
                if (jsonData.Items[0].Type.toLowerCase() === 'postcode') {
                    this.findAddresses(postalCode, resultsTarget, jsonData.Items[0].Id);
                } else {
                    const results = jsonData.Items.filter((res) => res.Type && res.Type.toLowerCase() === 'address');

                    for (const address of results) {
                        const newOption = document.createElement('option');
                        newOption.value = address.Id;
                        newOption.text = address.Text;
                        resultsTarget.appendChild(newOption);
                    }
                }
            }
        }).catch(error => {
            this.displayError(resultsTarget, error);
        }).then(() => {
            resultsTarget.parentElement.classList.remove('hidden-accessible');
        });
    }
}